import React, {useState} from 'react';

import styles from './styles.module.scss';
import {FAQ} from '../../../FAQ';
import {BottomCard} from '../../../Cards/BottomCard';
import {Comparisone} from '../../../Comparisone';
import {TierCards} from '../../../Cards/TierCard';

const Premium = () => {
  const [toggle, setToggle] = useState('monthly');
  const [active, setActive] = useState(false);

  const handleToggle = (state) => {
    setToggle(state);
  };

  return (
    <div className={styles.premium}>
      <div className={styles.top}>
        <div className={styles.left}>
          <h3 className={styles.title}>
            New Experience with <span className={styles.mark}>Premium</span> version
          </h3>
          <p className={styles.subTitle}>Elevate your server security to the next level</p>
        </div>
        <div className={styles.right}>
          <div className={styles.toggle}>
            <div
              className={`${styles.toggleButton} ${toggle === 'annually' && styles.active}`}
              onClick={() => handleToggle('annually')}>
              Annually <span className={styles.percent}>20%</span>
            </div>
            <div
              className={`${styles.toggleButton} ${toggle === 'monthly' && styles.active}`}
              onClick={() => handleToggle('monthly')}>
              Monthly
            </div>
          </div>
        </div>
      </div>
      <TierCards />
      <div className={styles.continue}>
        <div className={styles.textBlock}>
          <div className={styles.check}></div>
          <p className={styles.text}>
            I am acknowledged of, have read and agree to the Terms of Use and Privacy Policy. I give
            my consent to Themis to charge my card at post trial expiry and each billing period.
          </p>
        </div>
        <button className={styles.button}>Continue to payment</button>
      </div>
      <Comparisone toggle={toggle} active={active} setActive={setActive} />
      <div className={styles.bottomCardWrapper}>
        <BottomCard secondary />
      </div>
      <div className={styles.faqWrapper}>
        <FAQ />
      </div>
    </div>
  );
};

export default Premium;
